var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{attrs:{"query":_vm.GET_CUSTOMER,"variables":{ id: _vm.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.result.data;
var isLoading = ref.isLoading;
return [(isLoading)?_c('s-loader'):(data && data.customer)?_c('div',[(_vm.convertToForm(data.customer))?_c('CustomerForm',{attrs:{"data":_vm.convertToForm(data.customer),"query":_vm.UPDATE_CUSTOMER},on:{"mutation-done":_vm.customerUpdated}}):_vm._e()],1):_c('something-went-wrong')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }